const WiggleGlitchShader = {

	name: 'WiggleGlitchShader',

	uniforms: {

		'tDiffuse': { value: null },
		'opacity': { value: 1.0 },
		'time': { type: 'f', value: 0.002}
        

	},

	vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,

	fragmentShader: /* glsl */`

		uniform float opacity;

		uniform sampler2D tDiffuse;

		uniform float time;

		varying vec2 vUv;

        vec2 uv;

		float rand(vec2 co){
			return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
		}

          void texelCoord()
        {
          uv = vec2(vUv.x + ((rand(vec2(vUv.y + (time), 11.0)) * (pow(sin(time * 3.0), 9.0)))) / 100.0 , vUv.y);
          uv = vec2(uv.x + ((-rand(vec2(uv.y + (time), 211.0)) * (pow(sin(time * 3.0), 9.0)))) / 150.0 , uv.y);
          uv = vec2(uv.x + ((rand(vec2(uv.y + (time), 111.0)) * (pow(sin(time * 4.0), 5.0)))) / 80.0 , uv.y);
          uv = vec2(uv.x + ((-rand(vec2(uv.y + (time), 211.0)) * (pow(sin(time * 4.0), 5.0)))) / 200.0 , uv.y);
          uv = vec2(uv.x + ((rand(vec2(uv.y + (time), 111.0)) * (pow(sin(time * 5.0), 9.0)))) / 90.0 , uv.y);
          uv = vec2(uv.x + ((-rand(vec2(uv.y + (time), 211.0)) * (pow(sin(time * 5.0), 5.0)))) / 100.0 , uv.y);
        }

		void main() {

			texelCoord();
			vec4 texel = texture2D( tDiffuse, vec2(uv.x, uv.y) );
   
			gl_FragColor = texel * opacity;
   ;
		}`

};

